import { createFileRoute } from "@tanstack/react-router";

import { ProfileContainer } from "@/features/settings/containers/profile-container";

export const Route = createFileRoute("/app/settings/user/profile")({
  component: ProfileContainer,
});
